<script>
import nodeID from '@/mixins/nodeID'
import TemSelector from './TempalteSelector.vue'
import { getUploadFiles } from '@/api/upload'

export default {
  name: 'UploadedFilesSelector',
  extends: TemSelector,

  mixins: [nodeID],

  created() {
    this.init()
  },

  methods: {
    getList() {
      return new Promise((resolve, reject) => {
        getUploadFiles(this.nodeID)
          .then((res) => {
            const { data } = res
            const fileList = data.map((file) => `file://${file}`)
            resolve(fileList)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
  },
}
</script>
